import { useState, useMemo, useRef, memo, useEffect, useContext } from 'react';
import { GetMedicalRequest } from '@/api/endpoints/Requests';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import { CategoryRequestCell, NameRequestCell } from './RowsCells/RowsData';
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn';
import Status from './RowsCells/Status/Status';
import { DateRequestCell } from './RowsCells/RowsData/DateRequestCell';
import { useNavigate } from 'react-router-dom';
import ActionBtn from '@/components/ActionBtn';
import { CRRender } from '@/components/crRender';
import { PATIENT_REQUEST_STATUS, PATIENT_REQUEST_STATUS_MAP } from '@/data/status';
import { DomainContext } from '@/context/DomainContext';

const RoutingBase = '/panel/provider/medical-request';

const MedicalRequest = () => {

    const { customSearchData } = useContext(DomainContext)

    const navigate = useNavigate();

    console.log(customSearchData);

    const columns = useMemo(() => [

        {
            Header: 'PatientName',
            accessor: 'PatientName',
            canSearch: true,
            visible: false,
        },
        {
            Header: 'Date',
            accessor: 'Date',
            type: "Date",
            isMulti: true,
            canSearch: true,
            visible: false,
        },
        {
            Header: 'status',
            probName: 'statusId',
            accessor: 'statusId',
            options: PATIENT_REQUEST_STATUS_MAP,
            type: "DropDown",
            isMulti: true,
            canSearch: true,
            visible: false,
        },
        {
            Header: 'patientName',
            Cell: ({ row: { original } }) => <NameRequestCell original={original} />
        },
        {
            Header: 'requestDate',
            Cell: ({ row: { original } }) => <DateRequestCell original={original} />
        },
        {
            Header: 'categoryName',
            Cell: ({ row: { original } }) => <CategoryRequestCell original={original} />
        },
        {
            Header: 'status',
            Cell: ({ row: { original } }) => <Status status={{ name: original?.orderStatus, id: original?.orderStatusId }} />
        },
        {
            Header: 'view',
            Cell: ({ row: { original } }) => (
                <>
                    <BaseBtn onApply={() => viewRequestDetails(original)} action="show-details show" className="show-details details-info show-details-info" reqAction="canGet" icon={"fluent:eye-16-filled"} />
                    <CRRender isRender={original?.orderStatusId != PATIENT_REQUEST_STATUS?.Pending}>
                        <BaseBtn onApply={() => handleAdmission(original?.id, true)} action="payment-details" className="payment-details details-info show-details-info" icon={"famicons:pricetag"} />
                    </CRRender>
                </>
            )
        },
        {
            Header: 'action',
            accessor: 'action',
            Cell: ({ row: { original } }) =>
                <>
                    <CRRender
                        isRender={[PATIENT_REQUEST_STATUS?.Pending,
                        PATIENT_REQUEST_STATUS?.InformationRequested,
                        PATIENT_REQUEST_STATUS?.InformationResponded].includes(original?.orderStatusId)}>
                        <ActionBtn onApply={() => handleAddQuotation(original?.id, original)} title="add-quotation" className="details-info" icon={"material-symbols:price-change"} />
                    </CRRender>
                    <CRRender isRender={original?.orderStatusId == PATIENT_REQUEST_STATUS?.InitialPaymentReceived}>
                        <ActionBtn onApply={() => handleAdmission(original?.id)} title="add-mission" className="details-info" icon={"ep:open"} />
                    </CRRender>
                    <CRRender isRender={original?.orderStatusId === PATIENT_REQUEST_STATUS?.InProgress}>
                        <ActionBtn onApply={() => handlePostServiceEntry(original?.id)} title="post-service" className="details-info" icon={"wordpress:table-column-after"} />
                    </CRRender>
                </>
        },
    ], [])

    const viewRequestDetails = (original) =>
        navigate(`${RoutingBase}/${original?.id}/${original?.orderStatusId}`)


    const handleAddQuotation = (id, requestDetails) => {
        navigate(`${RoutingBase}/add-quotation`, {
            state: {
                requestId: id,
                patientName: requestDetails?.patientName,
                serviceContext: {
                    category: requestDetails?.categoryName,
                    subcategory: requestDetails?.subCategoryName,
                    service: requestDetails?.service,
                    age: requestDetails?.age,
                    requestId: requestDetails?.id
                }
            }
        });
    };

    const handleAdmission = (id, isPayment) =>
        navigate(`${RoutingBase}/admission`, { state: { requestId: id, isPayment } });

    const handlePostServiceEntry = (id) =>
        navigate(`${RoutingBase}/post-service-entry`, { state: { requestId: id } });

    return (
        <>
            <ReportContent tableAPI={GetMedicalRequest} columns={columns}>
                <ReportHeader  >
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(MedicalRequest);